"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AUTOCOMPLETE_ICON_SHOW_MENU = exports.AUTOCOMPLETE_ICON_HIDE_MENU = exports.AUTOCOMPLETE_ICON_CLOSE = exports.COMPONENT_TYPE = exports.MODE = exports.NOOP = exports.DIVIDER_POSITIONS = void 0;
var DIVIDER_POSITIONS = {
  TOP: 'top',
  BOTTOM: 'bottom'
};
exports.DIVIDER_POSITIONS = DIVIDER_POSITIONS;

var NOOP = function NOOP() {};

exports.NOOP = NOOP;
var MODE = {
  CHECKBOX: 'checkbox',
  RADIO: 'radio'
};
exports.MODE = MODE;
var COMPONENT_TYPE = {
  MULTISELECT: 'multiselect',
  DROPDOWN: 'dropdown',
  DIVIDER: 'divider'
};
exports.COMPONENT_TYPE = COMPONENT_TYPE;
var AUTOCOMPLETE_ICON_CLOSE = 'sbi-close';
exports.AUTOCOMPLETE_ICON_CLOSE = AUTOCOMPLETE_ICON_CLOSE;
var AUTOCOMPLETE_ICON_HIDE_MENU = 'sbi-chevron-up';
exports.AUTOCOMPLETE_ICON_HIDE_MENU = AUTOCOMPLETE_ICON_HIDE_MENU;
var AUTOCOMPLETE_ICON_SHOW_MENU = 'sbi-chevron-down';
exports.AUTOCOMPLETE_ICON_SHOW_MENU = AUTOCOMPLETE_ICON_SHOW_MENU;
//# sourceMappingURL=constants.js.map